import { Box } from '@mui/material';
import { useEffect } from 'react';
import { useAuthContext } from 'src/auth/useAuthContext';
import { useThemeSettingsContext } from 'src/components/settings/ThemeSettingsContext';
import { NavRecents } from '../NavRecents/NavRecents';
import { NavScroolbar } from '../shared/styles';
import { NavDirectMessage } from './NavDirectMessage';
import { NavTextChannel } from './NavTextChannel';
import { NavVoiceChannel } from './NavVoiceChannel';

export const NavCommunicate = () => {
  const { onChangeColorPresets } = useThemeSettingsContext();

  const { user } = useAuthContext();

  // biome-ignore lint/correctness/useExhaustiveDependencies: Needs to change color preset when settings changes
  useEffect(() => {
    onChangeColorPresets('communicate');
  }, [user?.settings?.themeMode]);

  return (
    // @ts-expect-error role is not supported by Scrollbar
    // biome-ignore lint/a11y/useSemanticElements: <explanation>
    <NavScroolbar role="navigation" aria-label="Main">
      <NavRecents />
      <NavVoiceChannel />
      <NavTextChannel />
      <NavDirectMessage />
      <Box width={1} minHeight={(theme) => theme.spacing(1.5)} />
    </NavScroolbar>
  );
};
